import React from 'react'
import ReactSelect from 'react-select'

var interval = 0;

const onSearch = (search) => {
  if(interval) clearTimeout(interval);
   interval = setTimeout(() => {
     search();
   }, 1000)
}

const MultiSelect = ({field, validate, search, clear}) => {
  let hasErrors = field.errors.length > 0 ? true : false

  let options = field.filteredOptions ? field.filteredOptions : field.options;

    for (var key in field.options) {
      if (field.name == 'SkillType' && !field.options[key].value.length && field.options[key].label !== "Lyricist" && field.options[key].label !== "Singer"){
        field.options[key]['className'] = "m-l-20";
      }
    }
  if(clear){
    field.value = '';
  }
  return (
    <div className={hasErrors ? 'form-group text-danger' : 'form-group'}>
      <label className="col-form-label col-form-label-sm">{field.rules.title}</label>
      <ReactSelect
        placeholder={field.placeholder}
        autosize={false}
        multi
        autoFocus
        options={options}
        simpleValue
        clearable={true}
        name={field.name}
        disabled={false}
        value={field.value}
        onChange={
          value => {
            validate(value, field);
            onSearch(search);
          }
        }
        searchable={true}
      />
      {field.errors.map((error, i) => (
        <div key={i} className="form-text text-danger">
          {error}
        </div>
      ))}
    </div>
  )
}

export default (MultiSelect)
